<template>
    <div class="row" id="campaign-details" v-cloak>
        <div class="col-md-12">
            <div id="campaign-details" class="campaign-box campaign-box--no_border">
                <div class="row">
                    <div class="col-xs-12">
                        <editable-field
                            class="campaign-details-subtitle pull-left"
                            v-model="campaign.name"
                            :class-name="'campaign-details__name'"
                            v-on:update="updateCampaignName">
                        </editable-field>
                        <div class="pull-left m-l-sm">
                            <slot></slot>
                        </div>
                        <div class="campaign-details__status m-l-sm pull-right" style="margin-top:3px;">
                            <ul class="campaign-details__summary list-unstyled" v-cloak>
                                <li class="campaign-details__option" v-show="canToggleBudget()" style="height:44px;">
                                    <br-switch
                                            v-model="campaign.is_budget_enabled"
                                            :disabled="loading"
                                            @input="changeBudgetStatus($event)"
                                            class="pull-right"
                                    >
                                    </br-switch>
                                    <span class="status-sm">Spend Cap</span>
                                </li>
                                <li class="campaign-details__option" style="height:44px;">
                                    <br-switch
                                            v-if="canEditCampaign()"
                                            v-model="campaign.is_active"
                                            :disabled="false"
                                            :open-value="1"
                                            :close-value="0"
                                            @input="changeCampaignStatus($event)"
                                            class="pull-right">
                                    </br-switch>
                                    <span v-if="campaign.is_active" class="status-sm">Campaign Activate</span>
                                    <span v-else class="status-sm">Campaign Inactive</span>
                                </li>
                                <li v-if="onlyStaffWithCampaigns()" class="campaign-details__option" style="height:44px;">
                                    <span class="status-sm">
                                        <a :href="editCampaignLink()" title="Edit Campaign">
                                            <span class="glyphicon glyphicon-edit campaign-edit-action"></span>
                                        </a>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="row" v-show="campaign.blnBankrateSelect">
                    <div class="col-xs-12" style="margin-top: -10px;">
                        <span style="font-weight: bold;">
                            Bankrate Select
                        </span>
                    </div>
                </div>

                <modal title="Copy Campaign"
                       v-show="campaignCopy.show"
                       :ok-text="'Copy'"
                       v-on:ok="copyCampaign"
                       v-on:cancel="campaignCopy.show = false" v-cloak>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label>Campaign Name</label>
                                <input type="text" class="form-control" v-model="campaignCopy.name">
                            </div>
                            <div class="form-group">
                                <label for="copyOptionOne">
                                    <input type="radio" value="0" v-model="campaignCopy.option" id="copyOptionOne">
                                    Include only active ad sets
                                </label>
                                <div class="clearfix"></div>
                                <label for="copyOptionTwo">
                                    <input type="radio" value="1" v-model="campaignCopy.option" id="copyOptionTwo">
                                    Include all ad sets
                                </label>
                            </div>
                        </div>
                    </div>
                </modal>
            </div>
        </div>
    </div>
</template>

<script>
    import store from './store'
    import { mapState } from 'vuex';
    import campaignCommon from 'js/campaigns/common'

    export default {
      store: store,
      name: "campaignDetails",

      mixins: [campaignCommon],

      props: ['campaignData'],

      data() {
        return {
            loading: false,
            baseUrl: window.Portal.baseUrl,
            campaign: {
              id: null,
              name: '',
              is_active: 1
            },
            campaignCopy: {
              name: '',
              option: "0",
              show: false
            }
        }
      },

      computed: mapState(['campaignDeactivatedByLastAdSet']),

      watch: {
        campaignDeactivatedByLastAdSet(newValue, oldValue) {
          if (newValue && !oldValue && this.campaign.is_active === 1) {
            this.campaign.is_active = 0;
          }
        }
      },

      methods: {
        updateCampaignName: function (name) {
          var currentName = String(this.campaign.name);
          this.campaign.name = name;

          this.$http.patch(route('campaigns.update', this.campaign.id), this.campaign).then(function (response) {
            if (!response.body.success) {
              this.notifyRollbar('Update Campaign Failure: components/campaigns/manager/details.vue@updateCampaignName: line 106', response);
              this.campaign.name = currentName;
            }
          }, function (error) {
            this.notifyRollbar('Update Campaign Failure: components/campaigns/manager/details.vue@updateCampaignName: line 106', error);
            this.campaign.name = currentName;
          });
        },

        editCampaignLink: function () {
          return route('campaigns.edit', this.campaignData.id);
        },

        deleteCampaign: function () {
          var vm = this;

          this.showConfirmMessage(null, function () {
            vm.$http.delete(route('campaigns.delete', vm.campaign.id)).then(function (response) {
              if (response.data.success) {
                vm.redirect(route(`campaigns.${vm.campaign.product_category.name.toLowerCase().replace(' ', '-')}.index`));
              } else {
                this.notifyRollbar('Delete Campaign Failure: components/campaigns/manager/details.vue@deleteCampaign: line 125', response);
              }
            }, function(error) {
              this.notifyRollbar('Delete Campaign Failure: components/campaigns/manager/details.vue@deleteCampaign: line 125', error);
            });
          });
        },

        copyCampaign: function () {
          var vm = this;
          this.campaignCopy.show = false;
          this.showLoading();

          this.$http.post(this.baseUrl + '/campaigns/' + this.campaign.id + '/copy', {
            'name': this.campaignCopy.name,
            'includeInactiveAdSets': Number(this.campaignCopy.option)
          }).then(function (response) {
            this.hideLoading();
            if (response.body.success) {
              this.showSuccessMessage('The campaign has been copied', function () {
                vm.redirect(vm.baseUrl + '/campaigns/' + response.body.campaign.id);
              });
            } else {
              this.notifyRollbar('Copy Campaign Failure: components/campaigns/manager/details.vue@copyCampaign: line 142', response);
            }
          }, function(error) {
            this.notifyRollbar('Copy Campaign Failure: components/campaigns/manager/details.vue@copyCampaign: line 142', error);
            this.manageErrors(error);
          });
        },

        changeCampaignStatus: function (status) {
          var url = this.baseUrl + '/campaigns/' + this.campaign.id + '/';
          const action = status ? 'activate' : 'deactivate';

          this.$http.put(url + action).then(function (response) {
            if (!response.body.success) {
              this.campaign.is_active = status ? 0 : 1;
            }
          }, function (error) {
            this.campaign.is_active = status ? 0 : 1;
            this.manageErrors(error);
          });
        },

        changeBudgetStatus: function (isBudgetEnabled) {
          var url = this.baseUrl + '/api/campaign/' + this.campaign.id + '/budget-enabled/' + (isBudgetEnabled ? 1 : 0);

          this.loading = true;
          this.$http.put(url).then(function (response) {
            this.loading = false;
            if (!response.body.success) {
              this.campaign.is_budget_enabled = isBudgetEnabled ? 0 : 1;
            }
          }, function (error) {
            this.loading = false;
            this.campaign.is_budget_enabled = isBudgetEnabled ? 0 : 1;
            this.manageErrors(error);
          });
        },

        hasNonOpenBudget() {
          return this.campaign.budgets && this.campaign.budgets[0] && this.campaign.budgets[0].budget_interval !== '9'
        },

        canEditCampaign: function() {
          if (this.campaign.is_advertiser_edit_blocked && !this.hasRole(['staff', 'engineer'])) {
            return false
          }

          return this.canEditWithSelect(this.campaign.blnBankrateSelect)
        },

        canToggleBudget: function() {
          return this.hasNonOpenBudget();
        }
      },

      mounted: function () {
        this.campaignData.is_active = Number(this.campaignData.is_active);
        this.campaign = this.campaignData;
        this.campaignCopy.name = this.campaignData.name + ' 1';
      }
    }
</script>

<style scoped>
    .campaign-details__summary li:last-child {
        margin-right: 0;
    }
    .campaign-edit-action {
        cursor: pointer;
        margin-right: -27px;
        margin-left: 12px;
        padding-top: 4px;
    }
</style>
